export default screenConfigComparison = {
  get: function(tutorMatching) {
    if (!(tutorMatching && tutorMatching.UiController)) return [];
    return [
      {
        id: 'zip',
        isInputScreen: true,
        inputScreen: {
          progress: '20%',
        },
        onLoad: function() {
          if (document.querySelector('.js-redirected-page')) {
            if (document.getElementById('city-preselected')) {
              formData.zip = document.getElementById('city-preselected').value;
            }
            tutorMatching.UiController.navNext();
          }
        }
      },  
      {
        id: 'subject',
        isInputScreen: true,
        inputScreen: {
          title: 'In welchem Fach?',
          progress: '40%',
        },
        onLoad: function() {
          if (document.querySelector('.js-comparison-nt-inputscreen') && !document.querySelector('.js-redirected-page')) {
            const redirectAfterZipLink = document.getElementById('inputScreen').dataset.redirectZip;
            window.location.href = redirectAfterZipLink + '?city=' + formData.zip;
          }

          if (document.querySelector('.footer .container')) {
            document.querySelector('.footer .container').classList.add('d-none');
          }

          if (document.getElementById('subject-preselected') && document.querySelector('.js-redirected-page')) {
            formData.subject = document.getElementById('subject-preselected').value;
            tutorMatching.UiController.navNext();
          }
        }
      },
      {
        id: 'level',
        isInputScreen: true,
        inputScreen: {
          progress: '60%',
        },
      },
      {
        id: 'intent',
        isInputScreen: true,
        inputScreen: {
          progress: '80%',
        },
      },
      {
        id: 'message',
        isInputScreen: true,
        inputScreen: {
          progress: '100%',
        },
      },
      {
        id: 'loader',
        isInputScreen: false,
        onLoad: function() {
          setTimeout(function() {
            
            tutorMatching.UiController.fetchResult();
          }, 750);
        }
      },{
        id: 'requestform',
        isInputScreen: false,
        onLoad: function() {
          var cipher = function cipher(salt) {
            var textToChars = function textToChars(text) {
              return text.split('').map(function (c) {
                return c.charCodeAt(0);
              });
            };
          
            var byteHex = function byteHex(n) {
              return ("0" + Number(n).toString(16)).substr(-2);
            };
          
            var applySaltToChar = function applySaltToChar(code) {
              return textToChars(salt).reduce(function (a, b) {
                return a ^ b;
              }, code);
            };
          
            return function (text) {
              return text.split('').map(textToChars).map(applySaltToChar).map(byteHex).join('');
            };
          };

          var generateLink = function(view, email) {
            var myCipher = cipher('mySecretSalt')
            var thxPageLink = $('#requestform')[0].dataset.linkredirect;
            return window.location.protocol + '//' + window.location.hostname + thxPageLink + myCipher(view) + '&id=' + myCipher(email);
          }

          setTimeout(function() {
            $('.bg-container, #matching-widget').addClass('compact');
            $('.comparison-bottom-text').addClass('d-none');
            $('.comparison-bottom-text').removeClass('d-flex');
            // $('.bg-container, #matching-widget').removeClass('max-height-630, min-height-630');
    
            var views = [
              'experience',
              'price',
              'flexibility'
            ];
            var view = formData.preference ? formData.preference : views[Math.floor(Math.random() * views.length)];
    
            var subjects = formData.subject;
            var city = formData.zip;
            var level = formData.level;
            var intent = formData.intent;
            var message = formData.message;
    
            var subject;
            var subjectArr = subjects.split(',');
            if (subjectArr && subjectArr.length > 0) {
              subject = subjectArr.shift();
            }
    
            if (subject) {
              var subjectOption =  $('select[name="trial_session_subject"] option').filter(function () { return $(this).html() == subject; });
    
              if (subjectOption && subjectOption.length) {
                subjectOption.prop('selected',true).change();
              }
            }
    
            $('.hs_nachhilfe_fcher').find('input').val(subjectArr.join(',')).change();
            $('.hs_trial_session_city').find('input').val(city).change();
            $('.hs_preference').find('input').val(view).change();
            $('.hs_intent').find('input').val(intent.join(', ')).change();
            $('.hs_message').find('input').val(message).change();
    
            var changeMail = function(context) {
              var email = context.val();
              var link = generateLink ? generateLink(view, email) : '';
              $('.hs_redirect_link').find('input').val(link).change();
            }
    
            $('.hs_schule').find('input').val(level).change();
    
            $('.hs_email input').change(function() {
              changeMail($(this));
            })
    
            $('.hs_email input').keyup(function(){
              if (window.hsFormTimeout) {
                clearTimeout(window.hsFormTimeout);
              }
              var that = $(this);
              window.hsFormTimeout = setTimeout(function() {
                changeMail(that);
              }, 300);
            });
          }, 500);
        }
      }
  ]}
};
